import axios from "axios";
import { BASE_URL } from "./apiconfig";
import {IUser} from "../../redux/models/user.model";

export const getUserData = async (token: string, impersonate_role?: string):Promise<IUser> => {
  try {
    const params = impersonate_role ? { impersonate_role } : {};
    const response = await axios.get(`${BASE_URL}/user`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });
    return response.data.data;
  } catch (error) {
    console.log("Failed to get user data. ", error);
    throw error;
  }
};
export const loginUserApi = async (credentials: { Email: string; Password: string }) => {
  try {
    const response = await axios.post(`${BASE_URL}/login`, credentials, {
      withCredentials: true // This tells axios to send cookies along with the request
    });
    return response.data;
  } catch (error) {
    console.log("Failed to login user. ", error);
    throw error;
  }
};

export const registerUserApi = async (credentials: { UserName: string; Email: string; Password: string; PasswordConfirmation: string; FirstName: string; LastName: string; DealerID: string }) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, credentials, {
      withCredentials: true
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async (token: string | null) => {
  try {
    await axios.post(`${BASE_URL}/logout`, null, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.log("Failed to logout. ", error);
    throw error;
  }
};

export const refreshAccessTokenApi = async () => {
  try {
      const response = await axios.post(`${BASE_URL}/refresh`, null, {
          withCredentials: true, // Include cookies in the request
          // Other tabs wait on this refresh (see tokenSync), so it must not hang, e.g. on a
          // dead connection right after the laptop wakes.
          timeout: 15000,
      });
      return response.data;
  } catch (error) {
      console.log("Failed to refresh access token. ", error);
      throw error;
  }
};

// Password API calls:
export const resetPasswordApi = async (credentials: { email: string; password: string, password_confirmation: string; token: string; }) => {
  try {
    const response = await axios.post(`${BASE_URL}/reset-password`, credentials, {
      withCredentials: true // This tells axios to send cookies along with the request
    });

    return response.data;
  } catch (error) {
    console.log("Failed to reset password. ", error);
    throw error;
  }
};

// Confirm username API calls:
export const confirmUsernameApi = async (credentials: { username: string;}) => {
  try {
    const response = await axios.post(`${BASE_URL}/confirm-username`, credentials, {
      withCredentials: true // This tells axios to send cookies along with the request
    });
    return response.data;
  } catch (error) {
    console.log("Failed to confirm username. ", error);
    throw error;
  }
};

// Request reset link API calls:
// Username is optional: with it, the reset targets that account; without it, the auth
// service either sends the reset link (one account) or emails the list of usernames.
export const requestResetLinkApi = async (credentials: { email: string; username?: string;}) => {
  try {
    const response = await axios.post(`${BASE_URL}/forgot-password`, credentials, {
      withCredentials: true // This tells axios to send cookies along with the request
    });
    return response.data;
  } catch (error) {
    console.log("Failed to request reset link. ", error);
    throw error;
  }
};

// Edit profile API:
export const changePasswordApi = async (token: string | null, credentials: {old_password: string, password: string, password_confirmation: string}) => {
  try {
    const response = await axios.put(`${BASE_URL}/user/update-password`, credentials, {
      withCredentials: true, // This tells axios to send cookies along with the request
      headers: { Authorization: `Bearer ${token}` }
    });
    return response;
  } catch (error) {
    console.log("Failed to change password. ", error);
    throw error;
  }
};

export const loginUserFromTokenApi = async (jwt:string|null) => {
  try {
    const response = await axios.get(`${BASE_URL}/my-spas?session_id=${jwt}`, {
      withCredentials: true // This tells axios to send cookies along with the request
    });
    return response.data;
  } catch (error) {
    console.log("Failed to login user. ", error);
    throw error;
  }}

  // Edit profile API:
export const updateUserApi = async (token: string | null, 
  updateInfo: {uuid: string, name?: string, username?: string, email?:string, dealership_id?:string, phone?:string|null}) => {
  try {
    const response = await axios.put(`${BASE_URL}/users/${updateInfo.uuid}/update-info`, updateInfo, {
      withCredentials: true, // This tells axios to send cookies along with the request
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("Failed to update user. ", error);
    throw error;
  }
};

export interface IUserAddress {
  address1: string | null;
  address2: string | null;
  address3: string | null;
  locality: string | null;
  region: string | null;
  post_code: string | null;
  country_id: number | null;
}

// Own address API (only ever returned to the logged-in user):
export const getUserAddressApi = async (token: string | null): Promise<IUserAddress> => {
  try {
    const response = await axios.get(`${BASE_URL}/user/address`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  } catch (error) {
    console.log("Failed to fetch address. ", error);
    throw error;
  }
};

export const updateUserAddressApi = async (token: string | null, address: IUserAddress): Promise<IUserAddress> => {
  try {
    const response = await axios.put(`${BASE_URL}/user/address`, address, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data.data;
  } catch (error) {
    console.log("Failed to update address. ", error);
    throw error;
  }
};

// Delete user API:
export const deleteUserApi = async (token: string | null, user_id: string) => {
  try {
    const response = await axios.delete(`${BASE_URL}/users/${user_id}`, {
      withCredentials: true,
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("Failed to delete user. ", error);
    throw error;
  }
};